import '../scss/organisms/_cmp-map.scss'

import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

const maps = [...document.querySelectorAll('.map')]
const key = maps[0]?.dataset.key

if (!key) {
  console.error('Google Maps: missing GOOGLE_MAPS_API_KEY')
} else {
  setOptions({
    key,
    version: 'weekly',
  })

  maps.forEach(async (el) => {
    const lat = parseFloat(el.dataset.lat)
    const lng = parseFloat(el.dataset.lng)

    if (isNaN(lat) || isNaN(lng)) return

    const { Map } = await importLibrary('maps')
    const { AdvancedMarkerElement } = await importLibrary('marker')

    const position = { lat, lng }

    const map = new Map(el, {
      center: position,
      zoom: 16,
      mapId: el.id,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      zoomControl: true,
    })

    new AdvancedMarkerElement({ map, position })
  })
}
